import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

let url = COOKIECONSTANT.REQUEST_HOST
const emptyListData = {
  page:{
    pageNum: 0,
    total: 0,
  },
  list: [],
}
// 查询推荐的问题分类列表
const getQuestionRecommendList = () => {
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.help.question.recommend-list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
// 分页查询指定分类下的问题列表
const getQuestionListByCategory = (params) => {
  return new Promise((resolve, reject) => {
    Api.get(url, {
      params,
      headers: {
        'X-Host':'mall.help.question.list-by-category',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then((data) => {
      if(data.status == 6003) {
        return resolve(emptyListData)
      }
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    })
    .catch(e => {
      reject(e)
    })
  })
}


export default {
  getQuestionRecommendList,
  getQuestionListByCategory,
}
